module.exports = __webpack_public_path__ + "static/media/maruti_nursing_home.b27a40c8.png";